<template>
    <select :name="name" @change="$emit('change')" :id="id ?? idinput" :class="getClasses()" :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)">
        <option v-if="placeholder" value="">{{ placeholder }}</option>
        <option v-for="(opt, index) in options" :key="index" :value="opt?.value ?? opt" :disabled="opt?.disabled ?? false">
            {{ opt?.text ?? opt }}</option>
    </select>
</template>

<script>

export default {
    name: "InputForm",
    props: {
        modelValue: {
            type: [Number, String],
            required: false,
        },
        id: {
            type: String,
            required: false,
        },
        idinput: {
            type: String,
            required: false,
        },
        name: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        isinvalid: {
            type: Boolean,
            required: false,
        },
        options: {
            type: Array,
            default: () => {return []}
        }},
    emits: ['update:modelValue'],
    methods: {
        getClasses() {
            return {
                'form-control': true,
                'is-invalid': this.isinvalid,
            }
        }
    },
}
</script>